import styled from 'styled-components'

const CustomError = styled.div`
color: #700;
margin-top:10px;
`
export { CustomError }
